import type { StepOptions } from 'shepherd.js';
import { createActionStep, createInfoStep, createSuccessStep, createWaitingStep } from './stepStyles';

/**
 * Applique automatiquement le style approprié à une étape selon ses caractéristiques
 * @param step - L'étape d'onboarding
 * @returns L'étape avec le style approprié
 */
export function autoStyleStep(step: StepOptions): StepOptions {
  // Si l'étape a déjà des classes définies, on ne la modifie pas
  if (step.classes) {
    return step;
  }

  // ACTION REQUISE : Si l'étape a canClickTarget=true ou advanceOn
  if (step.canClickTarget === true || step.advanceOn) {
    return createActionStep(step);
  }

  // ATTENTE : Si l'étape n'a pas de boutons ou seulement un bouton "Précédent"
  if (!step.buttons || step.buttons.length === 0 || (step.buttons.length === 1 && step.buttons[0].secondary)) {
    return createWaitingStep(step);
  }

  // SUCCÈS : Si le titre contient des émojis de succès ou des mots-clés
  const successKeywords = ['✅', '🎉', '✨', 'bravo', 'félicitations', 'terminé', 'réussi', 'parfait'];
  const title = (typeof step.title === 'string' ? step.title : '').toLowerCase();
  if (successKeywords.some((keyword) => title.includes(keyword))) {
    return createSuccessStep(step);
  }

  // Par défaut : informatif
  return createInfoStep(step);
}

/**
 * Applique automatiquement les styles à toutes les étapes d'un chapitre
 * @param steps - Array d'étapes
 * @returns Array d'étapes avec styles appliqués
 */
export function autoStyleChapter(steps: StepOptions[]): StepOptions[] {
  return steps.map(autoStyleStep);
}

/**
 * Helper pour créer rapidement une étape avec détection automatique du style
 * Usage: createSmartStep({ id: 'my-step', title: 'Mon titre', ... })
 */
export function createSmartStep(step: StepOptions): StepOptions {
  return autoStyleStep(step);
}
